import { TaxedPriceDto } from '@vpfa/rest-api/valuation';

export const getTradeInPrice = (prices: TaxedPriceDto): number => {
  return prices?.useCalculatedPrice ? prices?.calculatedTradeInPrice : prices?.avTradeInPrice ;
};

export const getRetailPrice = (prices: TaxedPriceDto): number => {
  return prices?.useCalculatedPrice ? prices?.calculatedRetailPrice : prices?.avRetailPrice;
};
